/**
 * Created by Jerker Nord on 2018-11-26.
 */
import {IGameModeChangedData} from "@nolimitcity/slot-game/bin/core/gamemode/GameMode";
import {
    IStillImageBackgroundConfig,
    StillImageBackground
} from "@nolimitcity/slot-game/bin/game/background/StillImageBackground";
import {IResizeData} from "@nolimitcity/slot-game/bin/core/stage/StageManager";
import {ThorGameConfig} from "../ThorGameConfig";
import {Orientation} from "@nolimitcity/slot-game/bin/core/stage/Orientation";
import {GameResources} from "@nolimitcity/slot-game/bin/core/resource/GameResources";
import {ThorGameMode} from "../gamemode/ThorGameMode";

export class ThorBackground extends StillImageBackground {

    public static thorBackground:ThorBackground;
    private _screenWidth:number;
    private _screenHeight:number;
    private _orientation:Orientation;

    constructor(config:IStillImageBackgroundConfig) {
        super(config);
        ThorBackground.thorBackground = this;
    }

    protected initAnimations():void {
        super.initAnimations();
    }

    protected onChangeBackground(data:IGameModeChangedData):boolean {
        const success = super.onChangeBackground(data);
        this.updateBackground();
        return success;
    }

    private updateBackground() {
        const background:PIXI.Sprite = this._backgroundSprite;
        background.anchor.set(0.5, 0.5);
        background.position.set(this._screenWidth * 0.5, this._screenHeight * 0.5);

        let scale:number = 1;
        if(this._orientation == Orientation.PORTRAIT) {
            //scale = Math.max(this._screenWidth / background.texture.width, this._screenHeight / background.texture.height);
            scale = Math.min(this._screenWidth / ThorGameConfig.instance.GAME_HEIGHT, this._screenHeight / ThorGameConfig.instance.GAME_WIDTH);
        } else {
            scale = Math.min(this._screenWidth / ThorGameConfig.instance.GAME_WIDTH, this._screenHeight / ThorGameConfig.instance.GAME_HEIGHT);
        }

        background.scale.set(scale, scale);

    }


    protected onResize(resizeData:IResizeData):void {
        this._screenWidth = Math.floor(resizeData.width / this._layer.scale.x);
        this._screenHeight = Math.floor(resizeData.height / this._layer.scale.y);

        this._orientation = resizeData.orientation;

        //Negate layer scaling offset.
        this.x = -this._layer.x / this._layer.scale.x;
        this.y = -this._layer.y / this._layer.scale.y;

        this.updateBackground();

    }
}